import { useMutation, useQueryClient } from "@tanstack/react-query";
import { saveLink } from "../api";
import { linksKeys } from "../queries/keys";

// Create or update an affiliate link; invalidates the list + aggregation.
export const useSaveLinkMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => saveLink(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: linksKeys.all });
    },
  });
};
